export default "/images/maximize-2.svg?c0438627e69ed628835559d8076f56de";